import { render, staticRenderFns } from "./FilialForm.vue?vue&type=template&id=3b377ef6&lang=html"
import script from "./FilialForm.vue?vue&type=script&lang=js"
export * from "./FilialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports